var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main" },
    [
      _c(
        "drag-dialog",
        _vm._g(
          _vm._b(
            {
              staticClass: "gl-new-dialogPop ",
              attrs: {
                title: _vm.$t("blExchangeAppointment.foreSpeak"),
                "is-show-follow": false,
              },
              on: { open: _vm.opened, close: _vm.closed },
            },
            "drag-dialog",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        ),
        [
          _c("div", { staticClass: "panel-body" }, [
            _c("div", { staticClass: "filter-container-content" }, [
              _c(
                "div",
                { staticClass: "table-container-new" },
                [
                  _c("el-form", { ref: "form", attrs: { model: _vm.form } }, [
                    _c("div", { staticClass: "item" }, [
                      _vm.hasDemurrage && _vm.isRequestCompleted
                        ? _c(
                            "div",
                            { staticClass: "calculation-result-area" },
                            [
                              _c("div", { staticClass: "result-header" }, [
                                _c("h3", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "blExchangeAppointment.calInfoBegin1"
                                      )
                                    )
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "result-content" }, [
                                _c("p", { staticClass: "calculation-info" }, [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t(
                                          "blExchangeAppointment.calDateInfoNotWithFromDate"
                                        )
                                      ) +
                                      "\n                    "
                                  ),
                                  _c("span", { staticClass: "date-text" }, [
                                    _vm._v(" " + _vm._s(this.blNo) + " "),
                                  ]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("blExchangeAppointment.from")
                                      ) +
                                      "\n                    "
                                  ),
                                  _c("span", { staticClass: "date-text" }, [
                                    _vm._v(
                                      " " + _vm._s(this.startMoveDate) + " "
                                    ),
                                  ]),
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("blExchangeAppointment.to")
                                      ) +
                                      "\n                    "
                                  ),
                                  _c("span", { staticClass: "date-text" }, [
                                    _vm._v(
                                      " " + _vm._s(this.endMoveDate) + " "
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "total-amount" }, [
                                  _c("p", { staticClass: "amount-info" }, [
                                    _c(
                                      "span",
                                      { staticClass: "amount-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.calAmountToCurrency"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "amount-value" },
                                      [_vm._v(_vm._s(_vm.demurrageAmount))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "amount-info" }, [
                                    _c(
                                      "span",
                                      { staticClass: "amount-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.calExchangeRate"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "amount-value" },
                                      [_vm._v(_vm._s(_vm.exchangeRate))]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "amount-info" }, [
                                    _c(
                                      "span",
                                      { staticClass: "amount-label" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t(
                                              "blExchangeAppointment.calConvertedToPHP"
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "amount-value" },
                                      [_vm._v(_vm._s(_vm.phpAmount))]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "p",
                                  { staticClass: "calculation-end-info" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "blExchangeAppointment.calInfoEnd"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]),
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-content" },
                        [
                          _c(
                            "hot-table",
                            {
                              ref: "hotTable",
                              attrs: {
                                "data-source-": _vm.tableData,
                                settings: _vm.hotSettings,
                                "current-page": _vm.listQuery.currentPage,
                                "page-size": _vm.listQuery.pageSize,
                                "selection-column-title": _vm.$t(
                                  "blExchangeAppointment.No"
                                ),
                              },
                            },
                            [
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "vesselCode",
                                  title: _vm.$t(
                                    "blExchangeAppointment.vesselCode"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "voyageNo",
                                  title: _vm.$t(
                                    "blExchangeAppointment.voyageNo"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "blNo",
                                  title: _vm.$t("blExchangeAppointment.blNo"),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "containerNo",
                                  title: _vm.$t(
                                    "blExchangeAppointment.containerNo"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "containerType",
                                  title: _vm.$t(
                                    "blExchangeAppointment.containerType"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "demurrageType",
                                  title: _vm.$t("blExchangeAppointment.dem"),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "dgFlag",
                                  title: _vm.$t("blExchangeAppointment.dg"),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "startDate",
                                  title: _vm.$t(
                                    "blExchangeAppointment.startDate"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "endDate",
                                  title: _vm.$t(
                                    "blExchangeAppointment.endDate"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "freeUntilDate",
                                  title: _vm.$t(
                                    "blExchangeAppointment.FreeUntil"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "overDays",
                                  title: _vm.$t(
                                    "blExchangeAppointment.OverDay"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "freeTimeNo",
                                  title: _vm.$t("blExchangeAppointment.ftNo"),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "realTargetCurrency",
                                  title: _vm.$t(
                                    "blExchangeAppointment.confirmCurrency"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "realFee",
                                  title: _vm.$t(
                                    "blExchangeAppointment.confirmAmount"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "amountTax",
                                  title: _vm.$t("blExchangeAppointment.tax"),
                                  "class-name": "htCenter",
                                },
                              }),
                              _vm._v(" "),
                              _c("hot-column", {
                                attrs: {
                                  width: "100",
                                  data: "calAmount4PHP",
                                  title: _vm.$t(
                                    "blExchangeAppointment.amount4PHP"
                                  ),
                                  "class-name": "htCenter",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("pagination", {
                            staticClass: "pagePanel",
                            staticStyle: { "text-align": "left" },
                            attrs: {
                              total: _vm.total,
                              page: _vm.listQuery.currentPage,
                              limit: _vm.listQuery.pageSize,
                            },
                            on: {
                              "update:page": function ($event) {
                                return _vm.$set(
                                  _vm.listQuery,
                                  "currentPage",
                                  $event
                                )
                              },
                              "update:limit": function ($event) {
                                return _vm.$set(
                                  _vm.listQuery,
                                  "pageSize",
                                  $event
                                )
                              },
                              pagination: _vm.handlePageChange,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "item-button center-buttons" },
                        [
                          _c(
                            "el-button",
                            {
                              staticClass: "btn-info-primary",
                              attrs: { disabled: !_vm.isRequestCompleted },
                              on: { click: _vm.handleClose },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("btn.close")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              attrs: {
                                type: "success",
                                disabled: !_vm.isRequestCompleted,
                              },
                              on: { click: _vm.handleDownloadExcel },
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.$t("btn.save")) +
                                  "\n                "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          !_vm.hasDemurrage
                            ? _c(
                                "el-button",
                                {
                                  staticClass: "btn-primary",
                                  on: { click: _vm.handleNext },
                                },
                                [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(_vm.$t("btn.nextStep")) +
                                      "\n                "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                  ]),
                ],
                1
              ),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }